import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { Transition } from 'react-transition-group';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import meShape from 'Workspace/types/me';

import {
  MessageBanner,
  MessageBannerHeader,
  MessageBannerTitle,
  MessageBannerParagraph,
  HelpMenuPrompt,
  HelpMenuPromptText,
} from './styles';
import messages from './messages';
import { BRONTE_BETA_STORAGE_KEY } from 'constants/constants';

function BetaMessage({ me, ...props }) {
  const [showBetaMessage, setShowBetaMessage] = useState(false);

  useEffect(() => {
    // Update localStorage whenever showBetaMessage changes
    localStorage.setItem(BRONTE_BETA_STORAGE_KEY, JSON.stringify(showBetaMessage));
  }, [showBetaMessage]);

  return (
    <React.Fragment>
      <Transition
        mountOnEnter
        unmountOnExit
        appear
        in={showBetaMessage}
        timeout={{ enter: 0, exit: 600 }}
      >
        {(status) => (
          <MessageBanner status={status} {...props}>
            <MessageBannerHeader>
              <MessageBannerTitle>{`Welcome to the Bronte beta${me && me.givenName ? `, ${me.givenName}` : ''}!`}</MessageBannerTitle>
              <Button white onClick={() => setShowBetaMessage(false)}>{intl.formatMessage(messages.dismissMessage)}</Button>
            </MessageBannerHeader>
            <MessageBannerParagraph>You are among the first people to experience Bronte and we are beyond thrilled to have you onboard. Bronte is in its beta version so despite our best efforts, you may come across some bugs or glitches. We value your feedback and request you to kindly reach out to us if you face any issues or have any suggestions for us using the feedback form below (the Question Mark button).</MessageBannerParagraph>
            <MessageBannerParagraph>We are working very hard to make Bronte a seamless experience for you. Thank you for being a part of this exciting journey. Beautiful learning experiences await!</MessageBannerParagraph>
          </MessageBanner>
        )}
      </Transition>
      {showBetaMessage &&
        <HelpMenuPrompt aria-hidden>
          <HelpMenuPromptText>Got feedback? let us know here</HelpMenuPromptText>
          <svg width="49" height="38" viewBox="0 0 49 38" xmlns="http://www.w3.org/2000/svg">
            <path d="M44.729 29.312l-4.591-5.933a1 1 0 1 1 1.582-1.224l5.616 7.258a1 1 0 0 1 .66.853l.337.435-7.721 6.79a1 1 0 1 1-1.32-1.501l5.322-4.681C25.4 30.55 10.659 20.559.488 1.429a1 1 0 0 1 1.766-.94C12.106 19.02 26.23 28.595 44.73 29.313z" />
          </svg>
        </HelpMenuPrompt>
      }
    </React.Fragment>
  );
}

BetaMessage.propTypes = {
  me: meShape,
};

const mapStateToProps = (state) => {
  const me = selectCurrentMe(state);
  return { me };
};

export default connect(mapStateToProps)(BetaMessage);
